import React, { useEffect, useState } from 'react';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import TwoFactorAuthService from '../../services/TwoFactorAuthService';
import { useForm } from 'react-hook-form';

const Enable2FactorAuth = () => {
    const { handleSubmit, register, formState: { errors } } = useForm();
    const [qrCode, setQrCode] = useState('');
    const [token, setToken] = useState('');

    const generateSecret = async () => {
        try {
            const response = await TwoFactorAuthService.generate();
            if (response.status === 200 && response?.data?.data?.qrCode) {
                setQrCode(response?.data?.data?.qrCode);
                console.log('Received QR:', response?.data?.data?.qrCode);
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        generateSecret();
    }, []);

    const onSubmit = async (data) => {
        try {
            const response = await TwoFactorAuthService.enable2FA({ data });
            if (response.status === 200) {
                console.log('2FA enabled successfully');
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader title="Two-Factor Authentication" />
                <div className="container-fluid p-4">
                    <PageHeader title="Two-Factor Authentication" />
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h3 className="mb-3">Set up your authenticator app</h3>
                                    <p>
                                        To use two-factor authentication (2FA), scan this QR code with an authenticator app like
                                        <strong> Google Authenticator</strong>, <strong>Authy</strong>, or <strong>1Password</strong>.
                                    </p>

                                    <div className="text-center my-4">
                                        {qrCode ? (
                                            <img src={qrCode} alt="2FA QR Code" style={{ width: '250px', height: '250px' }} />
                                        ) : (
                                            <p>Loading QR code...</p>
                                        )}
                                        <p className="mt-2 small text-muted">Scan this code with your app</p>
                                    </div>


                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="mb-3">
                                            <label className="form-label">Enter the code from your authenticator app</label>
                                            <input type="text"
                                                {...register('code',
                                                    { required: 'Code is required' })}
                                                className="form-control"
                                                placeholder="Enter the code"
                                                value={token}
                                                onChange={(e) => setToken(e.target.value)}
                                            />
                                            {errors.code && <div className="text-danger">{errors.code.message}</div>}
                                        </div>
                                        <button type="submit" className="btn btn-primary">Verify and Enable</button>
                                    </form>

                                </div>
                            </div>
                            <p className="text-muted mt-3 small">
                                Once 2FA is enabled, you'll need to provide a code from your authenticator app when logging in.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Enable2FactorAuth;
